/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AccountId } from "../../commons/types/AccountId";
import { EnvironmentId } from "../../commons/types/EnvironmentId";
import { SpaceId } from "../../commons/types/SpaceId";
export const ResourceIdUnion = core.serialization.undiscriminatedUnion([AccountId, EnvironmentId, SpaceId]);
